import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AutoCompleteModule } from 'ng5-auto-complete';
import { NgxPaginationModule } from 'ngx-pagination';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule } from '@angular/common/http';
//import { AngularEditorModule } from '@kolkov/angular-editor';
import { CKEditorModule } from 'ckeditor4-angular';
//import { CKEditorComponent } from '@ckeditor/ckeditor5-angular'; 
import { DirectivesModule } from '../../shared/directives/directives.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule, } from '@angular/material/sort';
//import { NgSelect2Module } from 'ng-select2';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatRadioModule } from '@angular/material/radio';
import { UserloginComponent } from '../../back-office/user-login/user-login.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import { NgxMaskModule } from 'ngx-mask';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { PipeModule } from '../../shared/pipe/pipe.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { UserLayoutRoutes } from './user-layout.routing';
import { FamilyMembersComponent } from '../../back-office/family-members/family-members.component';
import { personalInformation } from '../../back-office/personal-information/personal-information.component';
import { ProfileComponent } from '../../back-office/profile/profile.component';
import { PackageComponent } from '../../back-office/package/package.component';
import { HomeComponent } from '../../back-office/home/home.component';
import { ContactUsComponent } from '../../back-office/contact-us/contact-us.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PackageDetailsComponent } from '../../back-office/package-details/package-details.component';
import { BookingReviewComponent } from '../../back-office/booking-review/booking-review.component';
import { BookingsComponent } from '../../back-office/bookings/bookings.component';
import { SavedItineraryComponent } from '../../back-office/saved-itinerary/saved-itinerary.component';
import { MedicationsComponent } from '../../back-office/medications/medications.component';
import { FaqsComponent } from '../../back-office/faqs/faqs.component';
import { KumbhComponent } from '../../back-office/kumbh/kumbh.component';
import {NgxYoutubePlayerModule} from 'ngx-youtube-player';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { GtagModule } from 'angular-gtag';
import { DivineDestinationComponent } from '../../back-office/divine-destination/divine-destination.component';
import { TrendingFestivalComponent } from '../../back-office/trending-festival/trending-festival.component';
import { NgxMarqueeModule } from 'ngx-marquee';
import { WhoAreWeComponent } from '../../back-office/who-are-we/who-are-we.component';
import { AboutUsComponent } from '../../back-office/about-us/about-us.component';
import { WhyChooseUsComponent } from '../../back-office/why-choose-us/why-choose-us.component';
import { CancellationPolicyComponent } from '../../back-office/cancellation-policy/cancellation-policy.component';
import { HappyTravelerComponent } from '../../back-office/happy-traveler/happy-traveler.component';
import { AiTripComponent } from '../../back-office/admin/ai-trip-planner/ai-trip/ai-trip.component';
import { AiTripFirstComponent } from '../../back-office/admin/ai-trip-planner/ai-trip-first/ai-trip-first.component';
import { AiTripSecondComponent } from '../../back-office/admin/ai-trip-planner/ai-trip-second/ai-trip-second.component';
import { AiItineraryComponent } from '../../back-office/admin/ai-trip-planner/ai-itinerary/ai-itinerary.component';

FullCalendarModule.registerPlugins([
    // register FullCalendar plugins
    dayGridPlugin,
    interactionPlugin
]);

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'DD-MM-YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    },
};


@NgModule({
    imports: [
        CommonModule,
        PipeModule,
        DirectivesModule,
        RouterModule.forChild(UserLayoutRoutes),
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        MatButtonModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatMomentDateModule,
        MatRadioModule,
        Ng2SearchPipeModule,
        NgxPaginationModule,
        HttpClientModule,
        //AngularEditorModule,
        CKEditorModule,
        MatAutocompleteModule,
        MatSortModule,
        AutoCompleteModule,
        EditorModule,
        NgxSpinnerModule,
        NgOtpInputModule,
        InfiniteScrollModule,
        //SelectModule,
        NgSelectModule,
        NgxMatSelectSearchModule,
        FullCalendarModule,
        NgbModule,
        NgbDatepickerModule,
        NgxMarqueeModule,
        NgxMaskModule.forRoot(),
        NgxYoutubePlayerModule.forRoot(),
        BsDatepickerModule.forRoot(),
        GtagModule.forRoot({ trackingId: 'G-C89JDXREPJ', trackPageviews: true }),
    ],
    declarations: [
        UserloginComponent,
        HomeComponent,
        ProfileComponent,
        personalInformation,
        FamilyMembersComponent,
        PackageComponent,
        ContactUsComponent,
        PackageDetailsComponent,
        BookingReviewComponent,
        BookingsComponent,
        SavedItineraryComponent,
        MedicationsComponent,
        FaqsComponent,
        KumbhComponent,
        DivineDestinationComponent,
        TrendingFestivalComponent,
        WhoAreWeComponent,
        AboutUsComponent,
        WhyChooseUsComponent,
        CancellationPolicyComponent,
        HappyTravelerComponent,
        AiTripComponent,
        AiTripFirstComponent,
        AiTripSecondComponent,
        AiItineraryComponent
    ],
    bootstrap: [],
    providers: [
        DatePipe,
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
})

export class UserLayoutModule { }
